import r2wc from '@r2wc/react-to-web-component';
import Form from './Components/Form';
import './App.scss';

const BokaLaddbox = r2wc(Form);

customElements.define('boka-laddbox', BokaLaddbox);
